import { setWithBorderFlag } from '../../order-item-list/order-item-list-other.utils';
export const getProps = (size, index) => ({
  withBorder: setWithBorderFlag(size, index),
  isLastItem: size - 1 === index
});